import ResourcesAPI from '../../api/ResourcesAPI';
import {
  GET_TIERS_REQUESTED,
  GET_TIERS_SUCCESS,
  DELETE_TIERS_REQUESTED,
  ADD_TIER_REQUESTED,
  UPDATE_TIER_REQUESTED,
} from './TiersActionTypes';
import {
  ERROR,
} from '../central/CentralActionTypes';

export function getTiersSuccess(response) {
  return {
    type: GET_TIERS_SUCCESS,
    response,
  };
}

export function getTiers(apiToken) {
  return (dispatch) => {
    dispatch({ type: GET_TIERS_REQUESTED });
    return ResourcesAPI.getAllResources(apiToken, ['tiers'])
      .then(response => dispatch(getTiersSuccess(
        response.data,
      )),
      error => dispatch({
        type: ERROR,
        error,
      }));
  };
}

export function deleteTiers(apiToken, tierId) {
  return dispatch => {
    dispatch({ type: DELETE_TIERS_REQUESTED });
    ResourcesAPI.deleteResource(apiToken, ['tiers', tierId])
    .then(
      () => dispatch(getTiers(apiToken)),
      error => dispatch({
        type: ERROR,
        error,
      }),
    );
  }
}

export function addTier(apiToken, resource, ...resourcePath) {
  return (dispatch) => {
    dispatch({ type: ADD_TIER_REQUESTED });
    return ResourcesAPI.addResource(apiToken, resource, resourcePath)
      .then(
        () => dispatch(getTiers(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}

export function updateTier(apiToken, newResource, ...resourcePath) {
  return (dispatch) => {
    dispatch({ type: UPDATE_TIER_REQUESTED });
    return ResourcesAPI.updateResource(apiToken, newResource, resourcePath)
      .then(
        () => dispatch(getTiers(apiToken)),
        error => dispatch({
          type: ERROR,
          error,
        }),
      );
  };
}
